export default function range() {
    const ranges = document.querySelectorAll('.js-range');

    if ( !ranges ) return;

    ranges.forEach((range) => {
        const input = range.querySelector('.calc__range-input');
        const output = range.querySelector('.calc__range-value');

        if (!input || !output) return;

        const updateRange = () => {
            const min = Number(input.min);
            const max = Number(input.max);
            const value = Number(input.value);
            const progress = ((value - min) / (max - min)) * 100;

            output.value = value;
            input.style.setProperty('--range-progress', `${progress}%`);
        };

        input.addEventListener('input', updateRange);
        updateRange();
    });
}
